import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'

import { ArcoTheme, BaseStyles } from '@corabank/arco'

import { StepsProvider } from './context'
import GlobalStyle from './GlobalStyle'
import initMSW from './mocks'
import { Home } from './pages'
import { initDatadog } from './tracks'

initMSW()
initDatadog()

const rootElement = document.getElementById('root')
const root = createRoot(rootElement as HTMLElement)

root.render(
  <StrictMode>
    <BrowserRouter>
      <ArcoTheme>
        <BaseStyles />
        <GlobalStyle />
        <StepsProvider>
          <Home />
        </StepsProvider>
      </ArcoTheme>
    </BrowserRouter>
  </StrictMode>
)
